import React from 'react';
import { OrderPageData } from '../../../api';
import { SMSTemplatesPage } from '../../../smsTemplates/SMSTemplatesPage';

type SMSSectionProps = {
  orderPage: OrderPageData;
};

export const SMSSection = ({ orderPage }: SMSSectionProps) => {
  return <SMSTemplatesPage orderPageIdOverride={orderPage.id} />;
};
